import { useLandingSectionTracking } from '@/hooks/useLandingSectionTracking';

/**
 * Impression tracking for dense/sticky modules (BOO-3240 U7, decision #26):
 * the section tracker with a 0.1 threshold (compact modules may never reach
 * the 0.35 page-section bar when clipped by sticky chrome) and a mount
 * fallback where IntersectionObserver is unavailable, so the funnel never
 * silently loses a module. Kept as a named concept so call sites read as
 * "module impression", not a bag of options.
 */
export function useModuleImpression<T extends HTMLElement = HTMLElement>(moduleId: string) {
  return useLandingSectionTracking<T>(moduleId, {
    threshold: 0.1,
    fallbackOnUnsupported: true,
  });
}
